<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col text-center">
        <h1>{{ t('not_found.title') }}</h1>
        <p>{{ t('not_found.description') }}</p>
      </div>
    </div>
  </div>
</template>
